<section class="page-card login-card">
  <app-back-button-component />

  @if (isSubmitting) {
    <app-loading-component
      [flavorTextOptions]="[
        'Checking the guild ledger for your name.',
        'Matching your seal against the codex records.',
        'Confirming your credentials with the gatekeeper.',
        'Unlocking your place in the adventurer roster.',
        'Verifying your entry in the hall of names.'
      ]"
    />
  } @else {
    <div class="section-kicker">Adventurer Access</div>
    <h2 class="section-title">Log In</h2>
    <p class="empty-copy">
      Log in to open your place in the Codex.
    </p>

    <form class="login-form" (ngSubmit)="login()">
      <div class="form-group">
        <label for="username">Username</label>
        <input
          id="username"
          type="text"
          name="username"
          [(ngModel)]="username"
          placeholder="Enter username"
        />
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input
          id="password"
          type="password"
          name="password"
          [(ngModel)]="password"
          placeholder="Enter password"
        />
      </div>

      <div class="button-row">
        <button type="submit" class="primary-btn">
          Log In
        </button>
      </div>

      @if (errorMessage) {
        <p class="validation-text">{{ errorMessage }}</p>
      }
    </form>
  }
</section>
